import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d986154c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-10 py-6 trips-analytics" }
const _hoisted_2 = { class: "mt-9" }
const _hoisted_3 = { class: "mt-4 trips-analytics__container" }
const _hoisted_4 = {
  key: 0,
  class: "trips-analytics__state"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-red-500 text-sm" }, "При получении данных произошла ошибка", -1))
const _hoisted_6 = {
  key: 2,
  class: "text-sm"
}
const _hoisted_7 = {
  key: 1,
  class: "mt-4 flex flex-col gap-2"
}
const _hoisted_8 = { class: "flex items-center justify-end" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-file-excel mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_trips_analytics_filters = _resolveComponent("trips-analytics-filters")!
  const _component_loader = _resolveComponent("loader")!
  const _component_new_button = _resolveComponent("new-button")!
  const _component_trips_analytics_item = _resolveComponent("trips-analytics-item")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_page_title, { title: "Аналитика рейсов" }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_trips_analytics_filters, {
        loading: _ctx.state.is_loading,
        onSubmit: _ctx.onFiltersSubmit
      }, null, 8, ["loading", "onSubmit"]),
      _createElementVNode("div", _hoisted_3, [
        (_ctx.state.is_loading || _ctx.state.is_failed || _ctx.state.list.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              (_ctx.state.is_loading)
                ? (_openBlock(), _createBlock(_component_loader, {
                    key: 0,
                    class: "primary"
                  }))
                : (_ctx.state.is_failed)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _hoisted_5,
                      _createVNode(_component_new_button, {
                        type: "button",
                        class: "mt-1",
                        onClick: _ctx.loadTripsAnalytics
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Обновить")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ], 64))
                  : (_ctx.state.list.length === 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Нет данных"))
                    : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_new_button, {
                  type: "button",
                  loading: _ctx.state.is_export_loading,
                  onClick: _ctx.exportTripsAnalytics
                }, {
                  default: _withCtx(() => [
                    _hoisted_9,
                    _createTextVNode(" Экспортировать ")
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.list, (item) => {
                return (_openBlock(), _createBlock(_component_trips_analytics_item, {
                  key: item.tripNumber,
                  item: item
                }, null, 8, ["item"]))
              }), 128))
            ]))
      ])
    ])
  ]))
}